import Lottie from "lottie-react";
import reactionsAnim from "../../../lottie/reactions.json";

export default function CrystallizeTab() {
  return (
    <>
      <div className="crystallize-tab-wrap tab-wrapper-all">
        <div className="crystallize-tab-wrap__text tab-wrapper-all__text">
          <h2>Marketing that Connects</h2>
          <p>
            A brand’s strength lies in its connection with its audience. We
            transform presence into engagement and engagement into real results.
          </p>
          <h4>We build communities via:</h4>
          <ul>
            <li>PR and earned media</li>
            <li>Awards and events</li>
            <li>Social media strategy and execution</li>
            <li>Brand activations, partnerships, and collaborations</li>
          </ul>
          <span>Marketing isn’t a megaphone. It’s a magnet.</span>
        </div>
        <div className="crystallize-tab-wrap__anim tab-wrapper-all__anim">
          <Lottie animationData={reactionsAnim} loop={false} />
        </div>
      </div>
    </>
  );
}
